import { useEffect, useState } from 'react';
import { Title } from '../../../../utilities/interfaces/Title';
import { Chapter } from '../../../../utilities/interfaces/Chapter';
import { Agency } from '../../../../utilities/interfaces/Agency';
import { RecordStatuses } from '../../../../utilities/enums/RecordStatuses';

// redux
import { useAppSelector, useAppDispatch } from '../../../../app/hooks';
import { getFilteredTitles } from '../../../../features/state/StateTitle-slice';
import { getChaptersByTitleId } from '../../../../features/state/StateChapter-slice';
import { getFilteredAgencies } from '../../../../features/state/StateAgency-slice';
import { Draft } from '../../../../utilities/interfaces/Draft';
import { Workflow } from '../../../../utilities/interfaces/Workflow';
import { getAllWorkflows } from '../../../../features/state/StateWorkflow-slice';
import { filingActionAPI } from '../../../../utilities/api';

export const useCreateDraftModalController = (updateDraft: any) => {
  const dispatch = useAppDispatch();
  const titleList: Title[] = useAppSelector((state) => state.titles.filteredTitleList);
  const chapterValues: Chapter[] = useAppSelector((state) => state.chapters.chapters);
  const agencyValues: Agency[] = useAppSelector((state) => state.agency.filteredAgencies);
  const workflowValues: Workflow[] = useAppSelector((state) => state.workflows.workflows);
  const [draftName, setDraftName] = useState<string>('');
  const [selectedWorkflow, setSelectedWorkflow] = useState<any>();
  const [selectedAgency, setSelectedAgency] = useState<any>();
  const [selectedTitle, setSelectedTitle] = useState<any>();
  const [selectedChapter, setSelectedChapter] = useState<any>();
  const [createChapter, setCreateChapter] = useState<boolean>(false);
  const [chapterName] = useState<string>('');
  const [chapterNumber] = useState<number>(0);
  const [rulemakingActions, setRulemakingActions] = useState<any>([]);
  const [selectedAction, setSelectedAction] = useState<any>();

  useEffect(() => {
    if (agencyValues.length < 1) {
      dispatch(getFilteredAgencies());
    }
    if (workflowValues.length < 1) {
      dispatch(getAllWorkflows());
    }
    fetchRulemakingActions();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let draft: Draft = {
      draftName: draftName ?? null,
      agencyId: selectedAgency ? selectedAgency.id : null,
      titleId: selectedTitle ? selectedTitle.id : null,
      chapterId: selectedChapter && !createChapter ? selectedChapter.id : null,
      workflowId: selectedWorkflow ? selectedWorkflow.id : null,
      filingActionId: selectedAction ? selectedAction.id : null,
      isPromulgated: false,
    };
    let newChapter: any = {
      chapterName: chapterName ?? null,
      chapterNumber: chapterNumber ?? null,
    };
    createChapter ? updateDraft(draft, newChapter) : updateDraft(draft);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    draftName,
    selectedAgency,
    selectedTitle,
    selectedChapter,
    selectedAction,
    chapterName,
    chapterNumber,
    createChapter,
  ]);

  const handleTextFieldChange = (data: any) => {
    setDraftName(data);
  };

  const onWorkflowSelect = (data: any) => {
    setSelectedWorkflow(data.value);
  }

  const onAgencySelect = async (data: any) => {
    setSelectedAgency(data.value);
    setSelectedTitle(null);
    setSelectedChapter(null);
    dispatch(getFilteredTitles(data.value.id));
  };

  const onTitleSelect = (data: any) => {
    setSelectedTitle(data.value);
    setSelectedChapter(null);
    dispatch(getChaptersByTitleId(data.value.id));
  };

  const onChapterSelect = (data: any) => {
    setSelectedChapter(data.value);
  };

  const toggleChapterCreate = () => {
    if (createChapter) {
      setCreateChapter(false);
      setSelectedChapter(null);
    } else {
      setCreateChapter(true);
    }
  };

  const sanitizeChapterList = (data: Chapter[]) => {
    return data
      .filter(x => x.recordStatusId !== RecordStatuses.Draft)
      .map(x => {
        return {
          ...x,
          chapterName: x.chapterName === null ? '' : x.chapterName
        };
      });
  };

  useEffect(() => {
    if (createChapter || (!!selectedWorkflow && selectedWorkflow.id !== 1)) {
      setSelectedAction(undefined);
    }

    else if (!!rulemakingActions && rulemakingActions.length > 0) {
      setSelectedAction(rulemakingActions[0]);
    }
  }, [createChapter, rulemakingActions, selectedWorkflow])

  const fetchRulemakingActions = async () => {
    const actions: any = await filingActionAPI.getForDraft();
    setRulemakingActions(actions);
  }


  const onActionSelect = (data: any) => {
    setSelectedAction(data.value);
  }

  return {
    // redux
    titleList,
    chapterValues,
    agencyValues,
    workflowValues,
    // state
    selectedWorkflow,
    selectedAgency,
    selectedTitle,
    selectedChapter,
    createChapter,
    rulemakingActions,
    selectedAction,
    // functions
    handleTextFieldChange,
    onWorkflowSelect,
    onAgencySelect,
    onTitleSelect,
    onChapterSelect,
    toggleChapterCreate,
    sanitizeChapterList,
    onActionSelect,
  };
};
